<template>
	<keep-alive>
		<header class="topo topo--desktop">
			<div class="container">
				<div class="logo">
					<slot name="logo1" />
					<slot name="logo2" />
				</div>
				<slot name="menu" />
				<slot name="telefone" />

				<slot name="actions" />
			</div>
		</header>
	</keep-alive>
</template>

